import React, { useState } from 'react';
import './Monitoramento.css';

function Monitoramento() {
  const [open, setOpen] = useState(false);

  return (
    <section className="monitoramento-section" id="monitoramento">
      <div className="dots-animation">
        <span></span><span></span><span></span>
      </div>
      <h2>Monitoramento Prudencial</h2>

      <div className="accordion">
        <div className="accordion-header" onClick={() => setOpen(!open)}>
          <h3>Constanta Industrial LTDA</h3>
          <span>{open ? '▲' : '▼'}</span>
        </div>

        {open && (
          <div className="accordion-content">
            <p><strong>Fator de Alavancagem:</strong> 0,000227872800</p>
            <p><strong>Fator de Alavancagem de Risco:</strong> 0,000158783100</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default Monitoramento;
